import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 w-full border-b-2 border-gold-dark bg-crimson-dark text-white" data-id="element-268">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-center" data-id="element-269">
        <AlertTriangleIcon className="hidden h-4 w-4 shrink-0 text-gold-light sm:block" aria-hidden="true" data-id="element-270" />
        <motion.p animate={{
        opacity: [1, 0.55, 1]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-xs font-700 uppercase leading-tight tracking-wide sm:text-sm" data-id="element-271">
          Oferta de Lanzamiento — El precio sube a $59.999 · Cierra sin aviso
          después del 9 de agosto de 2026
        </motion.p>
      </div>
    </div>;
}